import React from "react";
import { NavLink } from "react-router-dom";

function PageNotFound() {
    return (
        <div className="page-not-found-container">
            <div className="error-content">
                {/* 404 Number */}
                <h1 className="error-404-number">
                    404
                </h1>

                {/* Error Icon */}
                {/* <div className="error-icon">
                    <i className="bi bi-exclamation-triangle-fill"></i>
                </div> */}

                {/* Main Message */}
                <h2 className="error-title">
                    Oops! Page Not Found
                </h2>

                {/* Description */}
                <p className="error-description">
                    The page you're looking for doesn't exist.
                </p>

                {/* Action Buttons */}
                <div className="error-buttons">
                    <NavLink
                        to="/"
                        className="error-btn-primary"
                    >
                        <i className="bi bi-house-fill me-2"></i>
                        Back to Home
                    </NavLink>

                    {/* <button
                        onClick={() => window.history.back()}
                        className="error-btn-secondary"
                    >
                        <i className="bi bi-arrow-left me-2"></i>
                        Go Back
                    </button> */}
                </div>
            </div>
        </div>
    );
}

export default PageNotFound;